import { render, staticRenderFns } from "./LandingAgeGrid.vue?vue&type=template&id=e0a864c0&scoped=true"
import script from "./LandingAgeGrid.vue?vue&type=script&lang=js"
export * from "./LandingAgeGrid.vue?vue&type=script&lang=js"
import style0 from "./LandingAgeGrid.vue?vue&type=style&index=0&id=e0a864c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a864c0",
  null
  
)

export default component.exports